import { JSX, useMemo } from 'react';

import { DateRangePicker, DateRangePickerProps } from '@semcore/ui/date-picker';

import CalendarIcon from '@/shared/ui/icons/Calendar';

import { getDateRangePickerPeriods } from '../lib/periods';

// have to use this transforms to handle timezones correctrly in DateRangePicker
export function YMDToDate(dateString: string) {
  const [year, month, day] = dateString.split('-').map(Number);

  return new Date(year, month - 1, day);
}

// have to use this transforms to handle timezones correctrly in DateRangePicker
export function dateToYMD(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

interface IDateRangeProps extends DateRangePickerProps {
  controlDisabled?: boolean;
}

export default function DateRange({
  controlDisabled,
  ...props
}: IDateRangeProps): JSX.Element {
  const triggerClassName = useMemo(
    () =>
      `date-picker cursor-pointer ${controlDisabled ? 'text-secondary pointer-events-none' : ''}`,
    [controlDisabled]
  );

  return (
    <div className="relative z-10">
      <DateRangePicker periods={getDateRangePickerPeriods()} {...props}>
        <DateRangePicker.Trigger
          size="m"
          className={triggerClassName}
          disabled={controlDisabled}
        />
        <DateRangePicker.Popper className="calendar" />
      </DateRangePicker>

      <CalendarIcon className="pointer-events-none absolute left-2 top-2 z-50" />
    </div>
  );
}
